"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiInputBaseOverrides = function (_a) {
    var _b, _c;
    var breakpoints = _a.breakpoints, typography = _a.typography, spacing = _a.spacing, palette = _a.palette;
    return ({
        root: (_b = {
                fontSize: typography.pxToRem(14),
                letterSpacing: "0.014em",
                lineHeight: 1.43
            },
            _b[breakpoints.up("xl")] = {
                fontSize: typography.pxToRem(16),
                lineHeight: 1.5,
                letterSpacing: "normal",
            },
            _b),
        multiline: {
            padding: 0,
        },
        input: (_c = {
                boxSizing: "border-box",
                height: spacing(12),
                // Regular without label
                padding: spacing(4, 3),
                // Regular with label
                "label + $formControl > &": {
                    paddingTop: spacing(6),
                    paddingBottom: spacing(2),
                },
                "&::placeholder": {
                    opacity: 0.7,
                    color: palette.text.secondary,
                }
            },
            _c[breakpoints.up("xl")] = {
                height: spacing(14),
                // Half the height, minus half the line height
                paddingTop: "calc(" + spacing(7) + "px - 0.75em)",
                paddingBottom: "calc(" + spacing(7) + "px - 0.75em)",
            },
            _c),
        inputMultiline: {
            // Multiline without label
            padding: spacing(2, 3),
            // Multiline with label
            "label + $formControl > &": {
                marginTop: spacing(6),
                padding: spacing(0, 3, 2),
            },
        },
    });
};
//# sourceMappingURL=MuiInputBase.js.map